<template>
    <div class="app-page">
        <section v-show="!loadingProducts" class="front-page-section">
            <div class="front-page-section__content" v-if="checkoutOpen">
                <CartItem
                        v-for="(product, index) in productsInCart"
                        :key="index"
                        v-bind:product="product">
                </CartItem>
                <div class="shop-page__checkout-summary">
                    <div class="shop-page__checkout-summary-details">
                        <p><span>Preces: </span><span class="common__price-color">{{ this.productsSumPrice }}€</span></p>
                        <p><span>Piegāde: </span><span class="common__price-color">{{ this.formData.deliveryMethod.value }}€</span></p>
                    </div>
                    <span class="shop-page__checkout-total">Kopā: </span><span class="common__price-color">{{ this.totalPrice }}€</span>
                </div>

                <div class="shop-page__checkout-details">
                    <v-row align="center">
                        <v-form
                                class="shop-page__form"
                                ref="form"
                                v-model="valid">
                            <v-text-field
                                    v-model="formData.name"
                                    label="Vārds"
                                    :rules="nameRules"
                                    required>
                            </v-text-field>
                            <v-text-field
                                    v-model="formData.surname"
                                    label="Uzvārds"
                                    :rules="nameRules"
                                    required>
                            </v-text-field>

                            <v-text-field
                                    v-model="formData.email"
                                    :rules="emailRules"
                                    label="E-pasts"
                                    required>
                            </v-text-field>

                            <v-text-field
                                    v-model="formData.phone"
                                    :rules="phoneRules"
                                    label="Telefona numurs"
                                    required>
                            </v-text-field>

                            <v-select
                                    v-model="formData.deliveryMethod"
                                    v-on:change="changeDeliveryMethod"
                                    return-object
                                    :items="items"
                                    :rules="[v => !!v || 'Norādiet piegādes veidu']"
                                    label="Piegādes veids"
                                    required>
                            </v-select>

                            <v-select
                                    v-if="formData.deliveryMethod.text === 'DPD pakomāts'"
                                    v-model="formData.pickup"
                                    :items="dpdPickupLocations"
                                    label="Norādi, kurā DPD pakomātā vēlies saņemt sūtījumu!"
                                    :rules="[v => !!v || 'Norādiet DPD piegādes vietu']"
                                    dense
                                    required>
                            </v-select>

                            <v-select
                                    v-if="formData.deliveryMethod.text === 'Omniva pakomāts'"
                                    v-model="formData.pickup"
                                    :items="omnivaPickupLocations"
                                    label="Norādi, kurā Omniva pakomātā vēlies saņemt sūtījumu!"
                                    :rules="[v => !!v || 'Norādiet Omniva piegādes vietu']"
                                    dense
                                    required>
                            </v-select>

                            <v-checkbox
                                    v-model="checkbox"
                                    :rules="[v => !!v || 'Lai turpinātu - jāpiekrīt.']"
                                    label="Piekrītu, ka mani dati tiks apstrādāti nolūkā piegādāt pasūtījumu."
                                    required>

                            </v-checkbox>
                            <div class="shop-page__checkout-btns">
                                <v-btn
                                        outlined
                                        class="mr-4"
                                        color="red"
                                        @click="returnToShop">
                                    Atpakaļ
                                </v-btn>
                                <v-btn
                                        outlined
                                        :disabled="!valid"
                                        class="mr-4"
                                        @click="completeOrder">
                                    Pasūtīt
                                </v-btn>
                            </div>
                        </v-form>
                    </v-row>
                </div>
            </div>

            <div class="front-page-section__content" v-else>
                <h1>Augu iedvesmoti t-krekli</h1>
                <div class="shop-page__shop-item-wrapper">
                    <ShopItem
                            v-for="(shirt, index) in shirts"
                            :key="index"
                            v-bind:productData = "shirt"
                    ></ShopItem>
                </div>
                <div class="shop-page__shirt-description">
                    <p>Atbalsti biedrības “AUGam” darbu, par ziedojumu iegādājoties t-kreklu ar Latvijā iemīļotiem ēdamaugiem! Tādējādi tu palīdzēsi veicināt augu valsts uztura izplatību un pieejamību Latvijā.</p>

                    <p>Krekli izgatavoti no 100% kokvilnas. To ražotājs ir uzņēmums “Sol’s”, kurš cita starpā ir organizācijas “Fair Wear Foundation” biedrs. Vairāk informācijas par uzņēmuma sertifikātiem un ražošanas standartiem skati <a target="_blank" href="https://www.sols-europe.com/gb/about-sols">šeit</a>.</p>

                    <p>Krekli ir unisex - tas nozīmē, ka šis modelis derēs gan sievietēm, gan vīriešiem. Jāņem vērā, ka sievietēm, kuras vēlas pieguļošu kreklu, iespējams, ir jāizvēlas mazāks izmērs, nekā ierasts sieviešu apģērbu veikalos. Precīzus izmērus skati tabulā.</p>

                    <p>Visu dizainu apdrukā ir izmantota pilnkrāsu digitālā druka, kas rezultātu padara īpaši kvalitatīvu un noturīgu.</p>

                    <p>Piegāde tiek veikta uz DPD un Omniva pakomātiem.</p>

                    <p>Kreklu dizains: <a href="https://www.instagram.com/kyaviinart/" target="_blank">Katrīna Juhna</a></p>
                </div>
                <div class="shop-page__shirt-sizes-cont">
                    <img
                        src="https://firebasestorage.googleapis.com/v0/b/augam-vegan.appspot.com/o/eshop%2Fshirts%2Fmob_picto_haut_corps.png?alt=media&token=e885547c-b7ff-4af1-869d-24e6b930c04c"
                        alt="kreklu izmēri"
                        height="100px"
                        width="100px">
                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                            <tr>
                                <th class="text-left">Izmērs</th>
                                <th class="text-left">A (garums, cm)</th>
                                <th class="text-left">B (platums, cm)</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in shirtSizes" :key="item.name">
                                <td>{{ item.name }}</td>
                                <td>{{ item.sizeA }}</td>
                                <td>{{ item.sizeB }}</td>
                            </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </div>
            </div>
        </section>

            <v-snackbar
                    style="position: fixed; top: 50px;"
                    v-model="notificationState"
                    top
                    absolute
                    :color="notificationColor"
            >{{notificationText}}</v-snackbar>


            <div v-show="loadingProducts" class="shop-page__loading-container">
                <v-progress-circular
                        class="shop-page__loading"
                        :size="70"
                        :width="7"
                        color="green"
                        indeterminate
                ></v-progress-circular>
            </div>
    </div>
</template>

<script>
    import { EventBus } from '../main.js';
    import firebaseCfg from "../firebaseConfig";
    import ShopItem from '../components/shop/ShopItem.vue';
    import CartItem from '../components/shop/CartItem.vue'

    export default {
        name: "ShopPage",
        components: {
            ShopItem, CartItem
        },
        data() {
            return {
                notificationState: false,
                notificationText: '',
                notificationColor: '',

                shirtSizes: [
                    {
                        name: 'S',
                        sizeA: 69,
                        sizeB: 50,
                    },
                    {
                        name: 'M',
                        sizeA: 72,
                        sizeB: 53,
                    },
                    {
                        name: 'L',
                        sizeA: 74,
                        sizeB: 56,
                    },
                ],

                loadingProducts: false,
                checkoutOpen: false,
                productsInCart: [],
                shirts: [],
                omnivaPickupLocations: [
                    "1905. gada iela 8A, Koknese",
                    "Abavas iela 4b, Kandava",
                    "Alauksta iela 2, Vecpiebalga",
                    "Anniņmuižas bulvāris 40a, Rīga",
                    "Anniņmuižas bulvāris 90,Rīga",
                    "Anniņmuižas iela 17, Rīga",
                    "Arhitektu iela 3, Daugavpils",
                    "Atbrīvošanas aleja 141, Rēzekne",
                    "Atmodas iela 6, Inčukalns",
                    "Atpūtas iela 5, Valdlauči",
                    "Augusta Dombrovska iela 23, Rīga",
                    "Augusta Dombrovska iela 74, Rīga",
                    "Ausekļa iela 54, Valka",
                    "Balvu iela 5, Viļaka",
                    "Baznīcas iela 1, Auce",
                    "Baznīcas iela 10, Jaunolaine",
                    "Baznīcas laukums 2, Smiltene",
                    "Biķernieku iela 160/6, Rīga",
                    "Biķernieku iela 16A, Rīga",
                    "Brīvības gatve 201, Rīga",
                    "Brīvības gatve 253, Rīga",
                    "Brīvības gatve 386, Rīga,",
                    "Brīvības gatve 434b, Rīga",
                    "Brīvības iela 13, Viļāni",
                    "Brīvības iela 30, Saldus",
                    "Brīvības iela 30,Dobele",
                    "Brīvības iela 34, Zilupe",
                    "Brīvības iela 35, Rīga",
                    "Brīvības iela 372, Rīga",
                    "Brīvības iela 8, Rūjiena",
                    "Celtnieku iela 3, Ventspils",
                    "Cietokšņa iela 60,Daugavpils",
                    "Dambja iela 10, Rīga",
                    "Daugavas iela 29, Mārupe",
                    "Daugavas iela 85, Pļaviņas, ",
                    "Daugavas iela 97, Skrīveri,",
                    "Daugavpils iela 6, Dagda",
                    "Deglava iela 110, Rīga",
                    "Deglava iela 67, Rīga",
                    "Dižozolu iela 2, Rīga",
                    "Driksas iela 4, Jelgava",
                    "Dundagas iela 18, Talsi",
                    "Dzelzavas iela 86, Rīga",
                    "Dzirciema iela 1, Rīga",
                    "Dzirciema iela 42, Rīga",
                    "Elizabetes iela 26, Rīga",
                    "Elizabetes iela 81, Rīga",
                    "G. Astras iela 7, Rīga",
                    "Gaismas iela 35, Aizkraukle",
                    "Gaiļezera iela 8, Rīga",
                    "Galdnieku iela 8, Rēzekne",
                    "Galvenā iela 1, Priekule",
                    "Ganību iela 187, Liepāja",
                    "Ganību iela 22/24, Ventspils",
                    "Ganību iela 69/71, Liepāja",
                    "Gaujas iela 1/3, Cēsis, ",
                    "Gaujas iela 19a, Vangaži",
                    "Gaujas iela 6, Ādaži",
                    "Gobas iela 13, Rīga",
                    "Gravas iela 1, Kuldīga",
                    "Grostonas iela 1, Rīga",
                    "Ieriķu iela 3, Rīga",
                    "Imantas 15. līnija 7,Rīga",
                    "J. Poruka iela 5, Ventspils",
                    "Jaunā Ostmala 3/5, Liepāja",
                    "Jelgavas iela 44, Jaunjelgava",
                    "Juglas iela 45, Rīga",
                    "Jūras iela 81, Engure",
                    "K.Valdemāra 62, Rīga",
                    "Kalnciema iela 41,Rīga",
                    "Katoļu iela 18, Jelgava",
                    "Katoļu iela 4, Rīga",
                    "Klaipēdas iela 104c, Liepāja",
                    "Kleistu iela 9, Rīga",
                    "Kr. Valdemāra iela 16a, Rēzekne",
                    "Krasta iela 46, Rīga",
                    "Krūmu iela 56",
                    "Kurzemes iela 36, Tukums",
                    "Kurzemes prospekts 132, Rīga",
                    "Kurzemes prospekts 1a, Rīga",
                    "Latgales iela 61, Ludza",
                    "Lidoņu iela 27, Rīga",
                    "Lielais prospekts 3/5, Ventspils",
                    "Lielcieceres iela 1, Brocēni",
                    "Lielirbes iela 29, Rīga",
                    "Lielā iela 13, Liepāja",
                    "Lielā iela 74, Grobiņa",
                    "Liepu aleja 15A, Babīte",
                    "Lāčplēša iela 14, Lielvārde",
                    "Mangaļu prospekts 29, Rīga",
                    "Maskavas iela 257, Rīga",
                    "Maskavas iela 357, Rīga",
                    "Maskavas iela 400, Rīga",
                    "Matīsa iela 25,Rīga",
                    "Mazcenu aleja 33-1 Jaunmārupe",
                    "Mednieku iela 21/23, Ogre",
                    "Miera iela 2, Rīga",
                    "Mārupes iela 10A, Rīga",
                    "Mīlgrāvja iela 6, Rīga",
                    "Mūkusalas iela 71, Rīga",
                    "Mūkusalas iela 73, Rīga",
                    "Nākotnes iela 2a,Valmiera",
                    "Nīcgales iela 2, Rīga",
                    "Nīcgales iela 53, Rīga",
                    "Nītaures iela 5, Augšlīgatne",
                    "Partizānu iela 8, Balvi",
                    "Parādes iela 5B, Rīga",
                    "Pasta iela 14, Tukums",
                    "Peldu iela 2, Ulbroka",
                    "Pils iela 9b, Alūksne",
                    "Pilskalnes iela 2A,Ilūkste",
                    "Pilsoņu iela 1k-1, Rīga",
                    "Pirts iela 5, Mālpils",
                    "Prāgas iela 1, Rīga",
                    "Prūšu iela 2, Rīga",
                    "Prūšu iela 22A, Rīga",
                    "Pulkveža brieža iela 33, Rīga",
                    "Raipoles iela 11, Daugavpils",
                    "Raiņa iela 26/28, Cēsis",
                    "Raiņa iela 6, Nereta",
                    "Reiņa iela 23, Viesīte",
                    "Rubenes iela 51, Valmiera",
                    "Rēzeknes iela 4, Preiļi",
                    "Rīgas gatve 5, Ādaži",
                    "Rīgas iela 109, Jēkabpils",
                    "Rīgas iela 11a, Jelgava",
                    "Rīgas iela 12, Ropaži",
                    "Rīgas iela 14, Baloži",
                    "Rīgas iela 14, Carnikava",
                    "Rīgas iela 2-4, Aloja",
                    "Rīgas iela 22, Ķekava",
                    "Rīgas iela 23, Ogre",
                    "Rīgas iela 24B, Vecumnieki",
                    "Rīgas iela 27, Iecava",
                    "Rīgas iela 28, Krāslava",
                    "Rīgas iela 3, Skaistkalne",
                    "Rīgas iela 33, Ogre",
                    "Rīgas iela 38,Salaspils",
                    "Rīgas iela 4, Valmiera",
                    "Rīgas iela 48, Jelgava",
                    "Rīgas iela 51, Saulkrasti",
                    "Rīgas iela 64, Valmiera",
                    "Rīgas iela 79, Baldone",
                    "Rīgas iela 8, Talsi, Talsi",
                    "Rīgas iela 8,Piņķi",
                    "Rīgas iela 89, Līvāni",
                    "Rūpniecības iela 49,Madona",
                    "Rūpniecības iela 77A, Jelgava",
                    "Saharova iela 14, Rīga",
                    "Satiksmes iela 35, Jelgava",
                    "Selgas iela 2, Roja",
                    "Sergeja Eizenšteina iela 29, Rīga",
                    "Skolas iela 1B, Ozolnieki",
                    "Skolas iela 4,Salaspils",
                    "Skolas iela 4a, Ikšķile",
                    "Skolas iela 7, Ugāle",
                    "Skolas iela 7,Gulbene",
                    "Sporta iela 6, Kārsava",
                    "Stacijas iela 2, Eleja",
                    "Stacijas iela 8,Limbaži",
                    "Stirnu iela 26, Rīga",
                    "Striķu iela 10C, Saldus",
                    "Strēlnieku iela 2, Sigulda",
                    "Strēlnieku prospekts 1,Jūrmala",
                    "Sūru iela 2, Kuldīga",
                    "Talejas iela 1, Rīga",
                    "Talsu iela 1, Dundaga",
                    "Talsu šoseja 29,Jūrmala",
                    "Talsu šosejas 8 km, Lapmežciems",
                    "Tilta iela 32, Rīga",
                    "Tirgus iela 1, Pāvilosta",
                    "Tirgus iela 10, Ragana",
                    "Tārgales iela 62, Ventspils",
                    "Ulbrokas iela 6, Rīga",
                    "Valdemāra iela 112",
                    "Valdeķu iela 10, Rīga",
                    "Valkas iela 1, Daugavpils",
                    "Valkas iela 2, Strenči",
                    "Valmieras iela 17a, Cēsis",
                    "Ventas iela 13, Skrunda,",
                    "Ventspils šoseja 32, Jūrmala",
                    "Veselības iela 1, Olaine",
                    "Vidus iela 1, Sigulda",
                    "Vidzemes iela 3a, Salacgrīva",
                    "Vienības gatve 144, Rīga",
                    "Vienības iela 1a, Jēkabpils",
                    "Vienības iela 7, Jēkabpils",
                    "Viestura iela 22,Jūrmala",
                    "Zaļā iela 1, Ērgļi",
                    "Zaļā iela 19,Dobele",
                    "Zaļā iela 3,Bauska",
                    "Ziepniekkalna iela 50, Rīga.",
                    "Zvaigžņu iela 2, Aizpute",
                    "Āzenes iela 5, Rīga",
                    "Ķeguma prospekts 5C,Ķegums",
                    "“Aleta”, Straupe,",
                    "“Jāņkrogs”, Jaunpils"
                ],
                dpdPickupLocations: [
                    "Uriekstes iela, Rīga, Paku Bode DPD Latvija",
                    "Stabu iela, Rīga, Paku Bode Bille bērnu apģērbi",
                    "Rīgas gatve, Ādaži, Paku Bode VIRŠI Ādaži",
                    "Merķeļa iela, Rīga, Paku Bode Copy Expert Merķelis",
                    "Blaumaņa iela, Rīga, Paku Bode Copy Expert Blaumanis",
                    "Gaismas iela, Aizkraukle, Paku Bode VIRŠI-A Gaisma",
                    "Rīgas iela, Pļaviņas, Paku Bode VIRŠI Pļaviņas",
                    "Jāņa Akurātera iela, Jēkabpils, Paku Bode VIRŠI Jēkabpils",
                    "Dobeles šoseja, Jelgava, Paku Bode Fitland",
                    "Raiņa iela, Auce, Paku Bode Ziedi Auce",
                    "Brīvības iela, Rūjiena, Paku Bode Freko Rūjiena",
                    "Raiņa iela, Cēsis, Paku Bode VIRŠI Cēsis",
                    "Rūjienas iela, Valka, Paku Bode VIRŠI Valka",
                    "Stacijas iela, Smiltene, Paku Bode VIRŠI Smiltene",
                    "Rīgas iela, Alūksne, Paku Bode VIRŠI Alūksne",
                    "Krasta iela, Balvi, Paku Bode VIRŠI Balvi",
                    "Rūpniecības iela, Madona, Paku Bode VIRŠI Madona",
                    "Abavas iela, Kandava, Paku Bode VIRŠI Kandava",
                    "Dižozolu iela, Rīga, Paku Bode Fotoveikals Mego",
                    "“Passim”, Malnavas pagasts, Kārsava, Paku Bode VIRŠI Kārsava",
                    "Nītaures iela, Mālpils, Paku Bode VIRŠI Mālpils",
                    "Jura Alunāna iela, Rīga, Paku Bode Copy Expert, A3 Salons",
                    "Rīgas iela, Iecava, Paku Bode Saimniecības preces",
                    "Daugavgrīvas iela, Rīga, Paku Bode VIRŠI Daugavgrīva",
                    "Uzvaras bulvāris, Rīga, Paku Bode VIRŠI Arkādijs",
                    "Ikri, Mārupe, Paku Bode VIRŠI Mārupe",
                    "Tvaika iela, Rīga, Paku Bode VIRŠI Sarkandaugava",
                    "Brīvības gatve, Rīga, Paku Bode VIRŠI Brīvība",
                    "Zvaigžņu iela, Aizpute, Paku Bode Freko Aizpute",
                    "Brīvības iela, Rīga, Paku Bode Circle K Brīvības/Cēsu",
                    "Pērnavas iela, Rīga, Paku Bode Circle K Pērnavas",
                    "Brīvības gatve, Rīga, Paku Bode Circle K Teika",
                    "K.Ulmaņa gatve, Mārupe, Paku Bode Circle K Mārupe",
                    "Mūkusalas iela, Rīga, Paku Bode Circle K Mūkusala",
                    "Lubānas iela, Rīga, Paku Bode Circle K Pļavnieki 2",
                    "Dzelzavas iela, Rīga, Paku Bode Circle K Dzelzavas",
                    "Jūrmalas gatve, Rīga, Paku Bode Circle K Botānika",
                    "Biķernieku iela, Rīga, Paku Bode Circle K Mežciems",
                    "Muitas iela, Rīga, Paku Bode Circle K Muitas",
                    "Zemnieku iela, Liepāja, Paku Bode VIRŠI Liepāja",
                    "Cerības, Krustkalni, Paku Bode VIRŠI Baloži",
                    "Milgrāvja iela, Rīga, Paku Bode Circle K Milgrāvis",
                    "Tvaika iela, Rīga, Paku Bode Circle K Sarkandaugava",
                    "Duntes iela, Rīga, Paku Bode Circle K Duntes",
                    "Kr.Valdemāra iela, Rīga, Paku Bode Circle K Valdemāra",
                    "Brīvības gatve, Rīga, Paku Bode Circle K VEF",
                    "Juglas iela, Rīga, Paku Bode Circle K Jugla",
                    "Gunāra Astras iela, Rīga, Paku Bode Circle K Purvciems1",
                    "Gunāra Astras iela, Rīga, Paku Bode Circle K Purvciems2",
                    "Deglava iela, Rīga, Paku Bode Circle K Deglava",
                    "Lubānas iela, Rīga, Paku Bode Circle K Pļavnieki1",
                    "Maskavas iela, Rīga, Paku Bode Circle K Ķengarags",
                    "Krasta iela, Rīga, Paku Bode Circle K Lido",
                    "Krasta iela, Rīga, Paku Bode Circle K Krasta",
                    "Krasta iela, Rīga, Paku Bode Circle K Daugava",
                    "Kurbada iela, Rīga, Paku Bode Circle K Kurbada",
                    "Eksporta iela, Rīga, Paku Bode Circle K Eksporta",
                    "Dzirciema iela, Rīga, Paku Bode Circle K Iļģuciems",
                    "Anniņmuižas bulvāris, Rīga, Paku Bode Circle K Imanta",
                    "K.Ulmaņa gatve, Rīga, Paku Bode Circle K Ulmanis 1",
                    "K.Ulmaņa gatve, Rīga, Paku Bode Circle K Ulmanis 2",
                    "Kalnciema iela, Rīga, Paku Bode Circle K Kalnciems",
                    "Vienības gatve, Rīga, Paku Bode Circle K Vienības",
                    "Ziepniekkalna iela, Rīga, Paku Bode Circle K Ziepniekkalns",
                    "Rīgas iela, Ogre, Paku Bode Circle K Ogre",
                    "Rīgas iela, Jēkabpils, Paku Bode Circle K Jēkabpils",
                    "Ventspils iela, Daugavpils, Paku Bode Circle K Daugavpils1",
                    "Stacijas iela, Daugavpils, Paku Bode Circle K Daugavpils2",
                    "Atbrīvošanas aleja, Rēzekne, Paku Bode Circle K Rēzekne",
                    "Brīvības iela, Gulbene, Paku Bode Circle K Gulbene",
                    "Cesvaines iela, Madona, Paku Bode Circle K Madona",
                    "Piebalgas iela, Cēsis, Paku Bode Circle K Cēsis",
                    "Stacijas iela, Valmiera, Paku Bode Circle K Valmiera1",
                    "Ausekļa iela, Valmiera, Paku Bode Circle K Valmiera2",
                    "Cēsu iela, Limbaži, Paku Bode Circle K Limbaži",
                    "Vidlauku iela, Ādaži, Paku Bode Circle K Ādaži",
                    "Dubultu prospekts, Jūrmala, Paku Bode Circle K Jūrmala",
                    "Meža iela, Tukums, Paku Bode Circle K Tukums",
                    "Jaunratnieki, Talsi, Paku Bode Circle K Talsi",
                    "Rūpniecības iela, Ventspils, Paku Bode Circle K Ventspils",
                    "Ganību iela, Kuldīga, Paku Bode Circle K Kuldīga",
                    "Ganību iela, Liepāja, Paku Bode Circle K Liepāja2",
                    "Esperanto iela, Liepāja, Paku Bode Circle K Liepāja1",
                    "Cukura iela, Liepāja, Paku Bode Circle K Liepāja3",
                    "Apvedceļš, Saldus, Paku Bode Circle K Saldus",
                    "Akadēmijas iela, Jelgava, Paku Bode Circle K Jelgava2",
                    "Zaļā iela, Bauska, Paku Bode Circle K Bauska",
                    "Zemkopības institūts, Skrīveri, Paku Bode VIRŠI Skrīveri",
                    "Kalngali, Sērene, Paku Bode VIRŠI Sērene",
                    "Varoņu iela, Jēkabpils, Paku Bode VIRŠI Krustpils",
                    "Somersētas iela, Aglona, Paku Bode VIRŠI Aglona",
                    "Bērziņi, Garbari, Paku Bode VIRŠI Ludza",
                    "Asni, Gauja, Paku Bode VIRŠI Asni",
                    "Tirgus iela, Ragana, Paku Bode VIRŠI Ragana",
                    "Kurzemes iela, Tukums, Paku Bode VIRŠI Tukums",
                    "Maskavas iela, Rīga, Paku Bode VIRŠI Rumbula",
                    "Nometņu iela, Salaspils, Paku Bode Circle K Salaspils",
                    "Krišjāņa Valdemāra iela 38, Rīga, Paku Bode Apavi40plus",
                    "Uriekstes iela 8a, Rīga, Paku Skapis DPD",
                    "Cietokšņa iela 60, Daugavpils, Paku Skapis TC Ditton nams",
                    "Lielā iela 13, Liepāja, Paku Skapis TN Kurzeme",
                    "Katoļu iela 18, Jelgava, Paku Skapis TC Vivo",
                    "Juglas krastmala 2, Rīga, Paku Skapis TC Jugla",
                    "A. Saharova iela 23a, Rīga, Paku Skapis Rimi Saharova",
                    "Kr. Valdemāra iela 112, Rīga, Paku Skapis Rimi Valdemārs",
                    "Lielirbes iela 29, Rīga, Paku Skapis TC Spice",
                    "Maskavas iela 357, Rīga, Paku Skapis TC Dole",
                    "A. Deglava iela 67, Rīga, Paku Skapis Maxima XXX Deglava",
                    "Kurzemes prospekts 1a, Rīga, Paku Skapis TC Damme",
                    "Brīvības gatve 372, Rīga, Paku Skapis TC Alfa",
                    "Ganību iela 22/24, Ventspils, Paku Skapis Mego Ventspils",
                    "Rīgas iela 4, Valmiera, Paku Skapis TC Valleta",
                    "Vienības iela 7, Jēkabpils, Paku Skapis TC Sēlija",
                    "Atbrīvošanas aleja 138, Rēzekne, Paku Skapis Rimi Rēzekne",
                    "Valmieras iela 17A, Cēsis, Paku Skapis Maxima XX Cēsis",
                    "Pasta iela 14, Tukums, Paku Skapis TC Rimi Tukums",
                    "Mednieku iela 21/23, Ogre, Paku Skapis TC Ogres Prestižs",
                    "Klaipēdas iela 62, Liepāja, Paku Skapis TC XL Sala",
                    "Daugavas iela 31, Mārupe, Paku skapis Rimi Mārupe",
                    "Pionieru iela 2, Bauska, Paku Skapis Rimi Bauska",
                    "Skolas iela 4e, Salaspils, Paku Skapis TC Rimi Salaspils",
                    "Rīgas iela 22a, Ķekava, Paku Skapis TC Liiba Ķekava",
                    "Cēsu iela 31, 3.K.(4 K.T.), Rīga, Paku Skapis Barons Kvartāls",
                    "Vidzemes šoseja 16, Sigulda, Paku Skapis TC Raibais Suns",
                    "Āzenes iela 5, Rīga, Paku Skapis TC Olimpia",
                    "Biķernieku iela 160, Rīga, Paku Skapis Rimi Biķernieku",
                    "Sporta iela 11 (autostāvvietā), Rīga, Paku Skapis Place Eleven",
                    "Talsu  šoseja 29, Jūrmala, Paku Skapis Rimi Kauguri",
                    "Smilšu iela 98, Daugavpils, Paku Skapis Maxima X Smilšu",
                    "Ieriķu iela 3, Rīga, Paku Skapis T/C Domina",
                    "Pulkveža Brieža iela 33A, Rīga, Paku Skapis Rimi P. Brieža",
                    "Augusta Dombrovska iela 74, Rīga, Paku Skapis Maxima X Vecmilgrāvis",
                    "Mārupes iela 10a, Rīga, Paku Skapis Rimi Āgenskalns",
                    "Imantas 15. līnija 7, Rīga, Paku Skapis Rimi Gramzdas",
                    "Gustava Zemgala Gatve 78, Rīga, Paku Skapis Jaunā Teika",
                    "Rīgas iela 23, Ogre, Paku Skapis TC Dauga",
                    "Georga Apiņa iela 10A, Valmiera, Paku Skapis Maxima XX Valmiera",
                    "TC A7, Krustkalni, Paku Skapis TC A7",
                    "Raipoles iela 11, Daugavpils, Paku Skapis TC Aveņu Centrs",
                    "Anniņmuižas bulvāris 90, Rīga, Paku Skapis Rimi Mini Anniņmuiža",
                    "Maskavas iela 257, Rīga, Paku Skapis Akropole",
                    "Lielais prospekts 3/5, Ventspils, Paku Skapis TC Tobago",
                    "Melioratoru iela 1a, Ikšķile, Paku Skapis Rimi Mini Ikšķile",
                    "Maskavas iela 400, Rīga, Paku Skapis TC Zoom",
                    "Brīvības iela 57, Balvi, Paku Skapis TC Planēta",
                    "Domes iela 4a, Līvāni, Paku Skapis Maxima XX Līvāni",
                    "Striķu iela 10b, Saldus, Paku Skapis TC Akvārijs",
                    "Jaunā ostmala 3/5, Liepāja, Paku Skapis TC Rietumu centrs",
                    "Tārgales iela 62, Ventspils, Paku Skapis Rimi Mini Ventspils",
                    "Rīgas iela 23a, Limbaži, Paku Skapis TOP Limbaži",
                    "Rīgas iela 11a, Jelgava, Paku Skapis TC Valdeka",
                    "Atbrīvošanas aleja 141a, Rēzekne, Paku Skapis Maxima XX Rēzekne",
                    "Rūpniecības iela 49, Madona, Paku Skapis Maxima XX Madona",
                    "Veselības iela 1, Olaine, Paku Skapis Maxima X Olaine",
                    "Viestura iela 22, Jūrmala, Paku Skapis Rimi Lielupe",
                    "Dzirciema iela 42, Rīga, Paku Skapis Rimi Iļģuciems",
                    "Vidus iela 1, Sigulda, Paku Skapis Elvi Sigulda",
                    "Lielā iela 2, Talsi, Paku Skapis Talsu Centrs",
                    "Rīgas gatve 5, Ādaži, Paku Skapis TC Apelsīns",
                    "Rēzeknes iela 7, Krāslava, Paku Skapis TOP Krāslava",
                    "Muldavas iela 3a, Dobele, Paku Skapis TC Forums",
                    "Pils iela 9A, Alūksne, Paku Skapis Maxima X Alūksne",
                    "Satiksmes iela 35, Jelgava, Paku Skapis RIMI Satiksmes",
                    "Raiņa iela 40a, Ludza, Paku Skapis Mego Ludza",
                    "Rīgas iela 4D, Preiļi, Paku Skapis TC Oga",
                    "Baznīcas laukums 2, Smiltene, Paku Skapis TC TOP Smiltene",
                    "Dzelzavas iela 78, Rīga, Paku Skapis Rimi Super Dzelzavas",
                    "Nīcgales iela 2, Rīga, Paku Skapis TC Minska",
                    "Gravas iela 1, Kuldīga, Paku Skapis Elvi Kuldīga",
                    "Vienības gatve 103, Rīga, Paku Skapis Rimi Mini Vienības",
                    "Rīgas iela 41, Gulbene, Paku Skapis Maxima X Gulbene",
                    "Gaismas iela 22, Aizkraukle, Paku Skapis Maxima X Aizkraukle",
                    "Lāčplēša iela 23b, Lielvārde, Paku Skapis Elvi Lielvārde",
                    "Krišjāņa Valdemāra iela 62a, Rīga, Paku Skapis RIMI Briāna",
                    "Gobas iela 13, Rīga, Paku Skapis Mego Bolderāja",
                    "Mūkusalas iela 73, Rīga, Paku Skapis Maxima XX Mūkusalas",
                    "Biķernieku iela 16A, Rīga, Pakus Skapis Mego Biķernieku"
                ],

                formData: {
                    name: "",
                    surname: "",
                    email: "",
                    phone: "",
                    deliveryMethod: 0,
                    deliveryMethodText: "",
                    pickup: "",
                    productCart: "",
                    orderID: "",
                    price: 0
                },

                valid: true,
                nameRules: [
                    v => !!v || 'Lūdzu aizpildiet lauciņu',
                ],
                emailRules: [
                    v => !!v || 'Lūdzu ievadiet e-pastu',
                    v => /.+@.+\..+/.test(v) || 'E-pastam jābūt derīgam',
                ],
                phoneRules: [
                    v => !!v || 'Lūdzu ievadiet telefona numuru',
                    v => /[0-9]{8,12}/.test(v) || 'Numuram jābūt derīgam',
                ],
                items: [
                    {
                        text: 'DPD pakomāts',
                        value: 2.49
                    },
                    {
                        text: 'Omniva pakomāts',
                        value: 2.88
                    },
                ],
                checkbox: false,
            }
        },
        methods: {
            pushNotification: function(color, text){
                this.notificationState = true;

                this.notificationColor = color;
                this.notificationText = text;

            },
            checkout: function(productsInCart){
                this.productsInCart = [];
                this.productsInCart = this.productsInCart.concat(productsInCart);
                this.checkoutOpen = true;
            },
            removeFromCart: function(removeProduct){
                this.productsInCart = this.productsInCart.filter(function(product){
                    return product.id !== removeProduct.id;
                });

                if(this.productsInCart.length === 0){
                    this.checkoutOpen = false;
                }
            },
            returnToShop: function(){
                this.checkoutOpen = false;
            },
            getProducts: function(){
                const that = this;
                const products = [];

                firebaseCfg.db.collection("storeShirts").get().then(function(querySnapshot){
                    querySnapshot.forEach(function(doc){
                        let shirts = doc.data();

                        products.push(shirts);
                        that.shirts = products;

                        that.loadingProducts = false;
                    })
                });
            },
            changeDeliveryMethod: function(){
                this.formData.pickup = '';
            },
            completeOrder: function(){
                const that = this;
                const orderId = Math.floor(Math.random() * 1000000 + 1)
                const submitData = that.$data.formData;
                const productCartArray = [];

                that.loadingProducts = true;

                that.productsInCart.forEach(function(product){
                    productCartArray.push([product.model + ":" + product.productSelector.name])
                });

                that.formData.productCart = productCartArray.toString();
                that.formData.deliveryMethodText = that.formData.deliveryMethod.text;
                that.formData.orderID = orderId.toString();
                that.formData.price = that.totalPrice;

                firebaseCfg.db.collection("orders").doc(orderId.toString()).set({
                    name: that.formData.name,
                    surname: that.formData.surname,
                    email: that.formData.email,
                    phone: that.formData.phone,
                    deliveryMethod: that.formData.deliveryMethod.text,
                    pickup: that.formData.pickup,
                    productCart: productCartArray.toString(),
                    price: that.totalPrice
                })
                .then(function() { })
                .catch(function(error) {
                    console.log(error)
                    that.loadingProducts = false;
                });

                const scriptURL = 'https://script.google.com/macros/s/AKfycby_kqGuG0Rvgp_PfZGstbokL9ZSDq5rhwbxaZ98v66padmVuTq7/exec';
                const formData = new FormData();

                Object.keys(submitData).forEach(function(key){
                    formData.append(key, submitData[key])
                });

                fetch(scriptURL, { method: 'POST', body: formData})
                    .then(function(){
                        that.checkoutOpen = false;
                        that.productsInCart = [];
                        EventBus.cart = [];
                        EventBus.$emit('shop--clear-cart', true);
                        that.loadingProducts = false;
                        that.pushNotification(
                            "green",
                            "Paldies, pasūtījums ir saņemts! Mēs ar jums drīzumā sazināsimies."
                        )
                    })
                    .catch(function(error){
                        console.log(error);
                        that.loadingProducts = false;
                        that.pushNotification(
                            "red",
                            "Notika kļūda veicot pasūtījumu. Mēģiniet vēlreiz vai rakstiet info@augam.lv."
                        )
                    })
            }
        },
        mounted(){
            this.loadingProducts = true;

            EventBus.$on('shop--checkout', this.checkout);
            EventBus.$on('shop--remove-from-cart', this.removeFromCart);

            this.getProducts();
        },
        computed: {
            totalPrice: function(){
                const deliveryValue = this.formData.deliveryMethod.value ? this.formData.deliveryMethod.value : 0;
                let totalPrice = this.productsInCart.reduce((sum, productPrice) => sum + productPrice.price, 0) + deliveryValue;
                return totalPrice.toFixed(2);
            },
            productsSumPrice: function(){
                return this.productsInCart.reduce((sum, productPrice) => sum + productPrice.price, 0);
            }
        }
    }
</script>

<style scoped>
    .app-page .front-page-section:nth-child(1){
        margin: 120px 0 0;
    }
    .front-page-section {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        font-size: 16px;
        color: #404040;
        position: relative;
    }
    .front-page-section__content {
        width: 94%;
        display: inherit;
        flex-direction: column;
        margin: 0 35px 0;
        text-align: start;
        z-index: 200;
        align-items: center;
    }
    .front-page-section__content h1 {
        margin: 0 0 20px 0;
        text-align: center;
        font-size: 46px;
    }
    .shop-page__loading-container{
        display: flex;
        margin-top: 120px;
    }
    .shop-page__loading{
        margin: 0 auto;
    }
    .shop-page__shop-item-wrapper {
        display: flex;
        flex-direction: row;
        align-content: space-between;
        justify-content: center;
        flex-wrap: wrap;
    }
    .shop-page__shirt-description {
        max-width: 720px;
        margin: 40px 0;
    }
    .shop-page__shirt-sizes-cont {
        display: flex;
        align-items: center;
        max-width: 720px;
        width: 100%;
        justify-content: space-evenly;
        margin-bottom: 40px;
        flex-wrap: wrap;
    }
    .shop-page__shirt-description > p{
        margin-bottom: 8px !important;
    }
    .shop-page__checkout-summary {
        max-width: 720px;
        width: 100%;
        text-align: right;
        font-size: 22px;
    }
    .shop-page__checkout-total {
        font-weight: bold;
    }
    .shop-page__checkout-summary-details {
        font-size: 16px;
    }
    .shop-page__form {
        width: 100%;
        padding: 0 15px;
    }
    .shop-page__checkout-details{
        max-width: 720px;
        width: 100%;
    }
    .shop-page__checkout-btns{
        display: flex;
        justify-content: right;
    }
</style>